/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiProfileClassification } from '../models/ApiProfileClassification';
import { HttpFile } from '../http/http';

export class ApiCreateOrUpdateProfileRequest {
    'handle': string;
    'banner_1'?: string | null;
    'banner_2'?: string | null;
    'website'?: string | null;
    'classification': ApiProfileClassification;
    'sub_classification': string | null;
    'pfp_url': string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "handle",
            "baseName": "handle",
            "type": "string",
            "format": ""
        },
        {
            "name": "banner_1",
            "baseName": "banner_1",
            "type": "string",
            "format": ""
        },
        {
            "name": "banner_2",
            "baseName": "banner_2",
            "type": "string",
            "format": ""
        },
        {
            "name": "website",
            "baseName": "website",
            "type": "string",
            "format": ""
        },
        {
            "name": "classification",
            "baseName": "classification",
            "type": "ApiProfileClassification",
            "format": ""
        },
        {
            "name": "sub_classification",
            "baseName": "sub_classification",
            "type": "string",
            "format": ""
        },
        {
            "name": "pfp_url",
            "baseName": "pfp_url",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiCreateOrUpdateProfileRequest.attributeTypeMap;
    }

    public constructor() {
    }
}



